import AuthorizedRoute from 'Components/AuthorizedRoute';
import { SITE_PAGES } from 'Config';
import withRouter from 'Lib/hoc/withRouter';
import { Navigate, Route, Routes } from 'react-router';
import ABRCodeListView from './ABR/ABRCodeListView';
import BudgetDetailsPage from './Budgets/BudgetDetailsPage';
import BudgetLandingView from './Budgets/BudgetLandingView';
import AccountDetailsPage from './ChargeAccounts/AccountDetailsPage';
import AccountListView from './ChargeAccounts/AccountListView';
import ExpenseCodeDetailsPage from './ExpenseCodes/ExpenseCodeDetailsPage';
import ExpenseCodeListView from './ExpenseCodes/ExpenseCodeListView';

let AccountDetailWithRouter = withRouter(AccountDetailsPage);
let ExpenseCodeDetailWithRouter = withRouter(ExpenseCodeDetailsPage);
let BudgetDetailWithRouter = withRouter(BudgetDetailsPage);

const Accounts = () => {
  return (
    <Routes>
      <Route
        index
        element={<Navigate to={SITE_PAGES.ALL_ACCOUNTS.to} replace />}
      />
      <Route
        path='accounts'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.ALL_ACCOUNTS.requiredAuth}>
            <AccountListView />
          </AuthorizedRoute>
        }
      />
      <Route
        path='accounts/:id'
        element={
          <AuthorizedRoute
            requiredAuth={SITE_PAGES.ACCOUNT_LANDING.requiredAuth}>
            <AccountDetailWithRouter />
          </AuthorizedRoute>
        }
      />
      <Route
        path='abr_codes'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.ABR_CODE.requiredAuth}>
            <ABRCodeListView />
          </AuthorizedRoute>
        }
      />
      <Route
        path='expense_codes'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.EXPENSE_CODE.requiredAuth}>
            <ExpenseCodeListView />
          </AuthorizedRoute>
        }
      />
      <Route
        path='expense_codes/:id'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.EXPENSE_CODE.requiredAuth}>
            <ExpenseCodeDetailWithRouter />
          </AuthorizedRoute>
        }
      />
      <Route
        path='budgets'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.BUDGETS.requiredAuth}>
            <BudgetLandingView />
          </AuthorizedRoute>
        }
      />
      <Route
        path='budgets/:id'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.BUDGETS.requiredAuth}>
            <BudgetDetailWithRouter />
          </AuthorizedRoute>
        }
      />
    </Routes>
  );
};

let Page = withRouter(Accounts);
export default Page;
